export default __webpack_public_path__ + "static/media/crisp.1a0682ac.png";